export default __webpack_public_path__ + "static/media/right-white.3c12a203.svg";